import { c as _c } from "react/compiler-runtime";
import { ApiWaveMetadataType } from "@/generated/models/ApiWaveMetadataType";
export default function CreateWaveDropsMetadataRowType(t0) {
  const $ = _c(15);
  const {
    activeType,
    onTypeChange
  } = t0;
  const STRING_CLASSES = activeType === ApiWaveMetadataType.String ? "tw-ring-primary-400 tw-bg-[#202B45] tw-text-primary-400 tw-z-10" : "tw-ring-iron-650 tw-bg-iron-900 hover:tw-bg-iron-800 tw-text-iron-300";
  const NUMBER_CLASSES = activeType === ApiWaveMetadataType.Number ? "tw-ring-primary-400 tw-bg-[#202B45] tw-text-primary-400 tw-z-10" : "tw-ring-iron-650 tw-bg-iron-900 hover:tw-bg-iron-800 tw-text-iron-300";
  let t1;
  if ($[0] !== onTypeChange) {
    t1 = () => onTypeChange(ApiWaveMetadataType.String);
    $[0] = onTypeChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `${STRING_CLASSES} tw-flex-shrink-0 tw-ring-1 tw-ring-inset focus:tw-z-10 tw-rounded-l-lg tw-whitespace-nowrap tw-flex-1 sm:tw-flex-none tw-w-12 tw-py-2.5 tw-text-sm tw-leading-5 tw-font-semibold tw-border-0 tw-transition-all tw-duration-300 tw-ease-out`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className="tw-h-5 tw-w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M4 7C4 6.06812 4 5.60218 4.15224 5.23463C4.35523 4.74458 4.74458 4.35523 5.23463 4.15224C5.60218 4 6.06812 4 7 4H17C17.9319 4 18.3978 4 18.7654 4.15224C19.2554 4.35523 19.6448 4.74458 19.8478 5.23463C20 5.60218 20 6.06812 20 7M9 20H15M12 4V20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t2) {
    t4 = <button onClick={t1} title="Text" className={t2} type="button">{t3}</button>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onTypeChange) {
    t5 = () => onTypeChange(ApiWaveMetadataType.Number);
    $[6] = onTypeChange;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = `${NUMBER_CLASSES} tw-flex-shrink-0 -tw-ml-px focus:tw-z-10 tw-ring-1 tw-ring-inset tw-whitespace-nowrap tw-flex-1 sm:tw-flex-none tw-w-12 tw-py-2.5 tw-text-sm tw-leading-5 tw-font-semibold tw-border-0 tw-transition-all tw-duration-300 tw-ease-out`;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <svg className="tw-h-4 tw-w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" aria-hidden="true"><path fill="currentColor" d="M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.8 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V64z" /></svg>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t5 || $[10] !== t6) {
    t8 = <button onClick={t5} title="Number" className={t6} type="button">{t7}</button>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t4 || $[13] !== t8) {
    t9 = <span className="tw-isolate tw-inline-flex tw-rounded-lg tw-shadow-sm">{t4}{t8}</span>;
    $[12] = t4;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}